import React from "react";
import PropTypes from "prop-types";
import { SignedImage } from "../common/SignedImage";

const DetailRow = ({ label, value }) => (
  <div className="d-flex justify-content-between align-items-start py-2 border-bottom">
    <span className="text-muted small fw-semibold text-uppercase" style={{ minWidth: "40%", letterSpacing: "0.05em" }}>
      {label}
    </span>
    <span className="text-end text-break" style={{ maxWidth: "58%" }}>
      {value || <span className="text-muted fst-italic">Not provided</span>}
    </span>
  </div>
);

DetailRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
};

const SectionCard = ({ title, children }) => (
  <div className="card shadow-sm mb-4">
    <div className="card-header bg-white border-bottom py-3">
      <h6 className="mb-0 fw-semibold text-dark">{title}</h6>
    </div>
    <div className="card-body px-3 py-2">{children}</div>
  </div>
);

SectionCard.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

const EngineerPersonalDetail = ({ userProfile, switchEditMode }) => {
  const profileImageExists = !!userProfile.engineerImageUrl;

  const fullName = [userProfile.title, userProfile.firstName, userProfile.lastName].filter(Boolean).join(" ");
  const fullAddress = [
    userProfile.address1,
    userProfile.address2,
    userProfile.address3,
    userProfile.city,
    userProfile.county,
    userProfile.postcode,
  ]
    .filter(Boolean)
    .join(", ");

  const isVatRegistered = userProfile.vatRegistered === true || userProfile.vatRegistered === "true";
  const companyTypeLabel = userProfile.companyType === "limitedCompany" ? "Limited Company" : "Sole Trader";

  return (
    <div>
      <div className="text-center mb-4">
        {profileImageExists ? (
          <SignedImage
            src={userProfile.engineerImageUrl}
            alt="Profile"
            className="rounded-circle border shadow-sm"
            style={{ width: 100, height: 100, objectFit: "cover" }}
          />
        ) : (
          <div
            className="rounded-circle bg-secondary d-inline-flex align-items-center justify-content-center border shadow-sm"
            style={{ width: 100, height: 100 }}
          >
            <span className="text-white fs-3 fw-bold">
              {userProfile.firstName ? userProfile.firstName.charAt(0).toUpperCase() : "?"}
            </span>
          </div>
        )}
        <h5 className="mt-3 mb-0 fw-semibold">{fullName}</h5>
        <p className="text-muted small">{userProfile.email}</p>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-6">
          <SectionCard title="Personal Information">
            <DetailRow label="Mobile Number" value={userProfile.mobileNumber} />
            <DetailRow label="Gas Safe Licence No." value={userProfile.gasSafeLicenseNumber} />
          </SectionCard>
        </div>
        <div className="col-12 col-md-6">
          <SectionCard title="Company Information">
            <DetailRow label="Company Name" value={userProfile.companyName} />
            <DetailRow label="Address" value={fullAddress} />
            <DetailRow label="Company Type" value={companyTypeLabel} />
            <DetailRow label="Gas Safe Number" value={userProfile.companyGasSafeNumber} />
            {userProfile.companyType === "limitedCompany" && (
              <DetailRow label="Company Number" value={userProfile.companyNumber} />
            )}
            <DetailRow label="VAT Registered" value={isVatRegistered ? "Yes" : "No"} />
            {isVatRegistered && <DetailRow label="VAT Number" value={userProfile.vatNumber} />}
          </SectionCard>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-6 col-lg-4 d-grid">
          <button type="button" className="btn btn-primary" onClick={switchEditMode}>
            Update Personal Details
          </button>
        </div>
      </div>
    </div>
  );
};

EngineerPersonalDetail.propTypes = {
  userProfile: PropTypes.object.isRequired,
  switchEditMode: PropTypes.func.isRequired,
};

export default EngineerPersonalDetail;
